"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetCohortsParams", {
    enumerable: true,
    get: function() {
        return GetCohortsParams;
    }
});
const _zod = require("zod");
const GetCohortsParams = _zod.z.object({
    cohortStatus: _zod.z.enum([
        "active",
        "archived"
    ]).optional()
});
